export default __webpack_public_path__ + "static/media/bariol_regular-webfont.0a23fbd1.woff2";